import { useContext, useState, useEffect } from "react";
import { LanguageContext } from "../../../utils/lang_provider";
import { Calendar, Flex, Input, TimePicker, Button, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { fetchData, postData } from "../../../utils/fetch";
import TextEditor from "../../../utils/text_editor";
import dayjs from 'dayjs'
import UploadThumbnailWidget from './uploadThumbnailWidget.js'
import { SaveOutlined } from '@ant-design/icons';

export default function EditTrainings({ isOffer }) {
    const { id } = useParams();
    const isEdit = Boolean(id);
    const type = isOffer ? "trainingOffers" : "trainings";
    const { language, setLanguage } = useContext(LanguageContext);

    const TodayDate = dayjs().format('YYYY-MM-DD');
    const NowTime = dayjs().format('HH:mm:ss');

    const [object, setObject] = useState(null);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [startDate, setStartDate] = useState(TodayDate);
    const [startTime, setStartTime] = useState(NowTime);
    const [endDate, setEndDate] = useState(TodayDate);
    const [endTime, setEndTime] = useState(NowTime);
    const [address, setAddress] = useState("");
    const [duration, setDuration] = useState("");

    useEffect(() => {
        if (!isEdit) return;

        async function loadContent() {
            try {
                const data = await fetchData(`admin/${type}/${id}`, language);
                setObject(data);
                setTitle(data.title);
                setContent(data.content);
                if (isOffer) {
                    setDuration(data.duration);
                } else {
                    setStartDate(data.start_date);
                    setEndDate(data.end_date);
                    setStartTime(data.start_time);
                    setEndTime(data.end_time);
                    setAddress(data.address);
                }
            } catch (error) {
                message.error("Could not load content page.");
            }
        }

        loadContent();
    }, [id, language]);

    const handleSave = async () => {
        let userId = object?.author;

        if (!isEdit) {
            try {
                const userRes = await fetchData(`admin/user/${localStorage.getItem("user")}`, language);
                userId = userRes.id;
            } catch (err) {
                message.error("Could not load user.");
                return;
            }
        }

        const baseData = {
            id: isEdit ? object.id : undefined,
            title: title,
            content: content,
            language_id: object?.language_id || language,
            author: userId,
            status: 1,
            created: object?.created || undefined,
            updated: object?.updated || undefined
        };

        const payload = isOffer
            ? {
                ...baseData,
                duration: parseInt(duration) || 0,
            }
            : {
                ...baseData,
                start_date: startDate,
                end_date: endDate,
                start_time: startTime,
                end_time: endTime,
                address,
            };

        try {
            await postData(`admin/content/update/${type}`, payload, payload.language_id);
            message.success(isEdit ? "Successfully updated." : "Successfully created.");
        } catch (error) {
            message.error("An error occurred.");
        }
    };

    /* STYLES */
    const wrapperStyle = {
        width: 300,
    };

    return (
        <Flex vertical style={{ margin: "2% 5% 0 5%", gap: "20px" }}>
            <Input placeholder={"Názov"} value={title} onChange={(e) => setTitle(e.target.value)} />
            <TextEditor value={content} setValue={setContent} />

            {isOffer ? (
                <div>
                    <Input
                        placeholder={"Dĺžka školenia"}
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                    />
                    <Button color="red" style={{ marginTop: "10px" }} onClick={handleSave}>
                        <SaveOutlined /> Save
                    </Button>
                    {isEdit && object && <UploadThumbnailWidget type={type} object={object} />}
                </div>
            ) : (
                <Flex vertical gap={20}>
                    <Input
                        placeholder={"Adresa"}
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                    />
                    <Flex justify="space-evenly" style={{ margin: "10px 0 10px 0" }}>
                        <Flex vertical>
                            <h2>Start Date</h2>
                            <div style={wrapperStyle}>
                                <Calendar
                                    value={dayjs(startDate, "YYYY-MM-DD")}
                                    fullscreen={false}
                                    onChange={(date) => setStartDate(date.format('YYYY-MM-DD'))}
                                />
                            </div>
                            <h2>Start Time</h2>
                            <TimePicker
                                value={dayjs(startTime, "HH:mm:ss")}
                                onChange={(time, timeString) => setStartTime(timeString)}
                            />
                        </Flex>
                        <Flex vertical>
                            <h2>End Date</h2>
                            <div style={wrapperStyle}>
                                <Calendar
                                    value={dayjs(endDate, "YYYY-MM-DD")}
                                    fullscreen={false}
                                    onChange={(date) => setEndDate(date.format('YYYY-MM-DD'))}
                                />
                            </div>
                            <h2>End Time</h2>
                            <TimePicker
                                value={dayjs(endTime, "HH:mm:ss")}
                                onChange={(time, timeString) => setEndTime(timeString)}
                            />
                        </Flex>
                    </Flex>
                    {isEdit && object && <UploadThumbnailWidget type={type} object={object} />}
                    <Button color="red" style={{ marginTop: "10px" }} onClick={handleSave}>
                        <SaveOutlined /> Save
                    </Button>
                </Flex>
            )}
        </Flex>
    );
}
